import { createFileRoute } from '@tanstack/react-router'
import ConversasPage from '@/pages/conversas/conversas-page'

// Rota index para /dashboard/$dashboardId/conversas/$channelInstanceUuid/$conversationId
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/conversas/$channelInstanceUuid/$conversationId/',
)({
  component: function ConversaDetailRoute() {
    const { dashboardId, channelInstanceUuid, conversationId } =
      Route.useParams()
    return (
      <ConversasPage
        dashboardId={dashboardId}
        channelInstanceUuid={channelInstanceUuid}
        conversationId={conversationId}
      />
    )
  },
})
